import { useState } from "react";
import { useRecoilValue } from "recoil";
import { browseBannerState, browseBannerMessageState } from "atoms";
import CardBroadbandLabel from "./CardBroadbandLabel";
import { setSpeeds } from "utils";
import { Modal } from "react-bootstrap";
import { postBrowsePage } from "services/post-browsePage";
import { overlayState, toastState } from "atoms";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState, useRecoilState } from "recoil";
import { useLocation } from "react-router-dom";
import { PATH } from "utils/const";

interface FieldName {
  fieldName: string;
}

const Banner = () => {
  const [showLegalInfoModal, setShowLegalInfoModal] = useState(false);
  const [toast, setToast] = useRecoilState(toastState);
  const browseBanner = useRecoilValue(browseBannerState);
  const navigate = useNavigate();
  const setShowOverlay = useSetRecoilState(overlayState);
  const browseBannerMessage = useRecoilValue(browseBannerMessageState);
  const bannerContent = browseBanner?.contentItemEcommerce?.contentEcommerce;
  const location = useLocation();

  let browseBannerBullets;
  let browseBannerImage;
  let browseBannerTitle;
  let browseBannerSubTitle;
  let browseBannerLegalInfo;

  if (bannerContent) {
    browseBannerBullets = bannerContent.find((obj: FieldName) => obj.fieldName === "browseBannerBullets");
    browseBannerImage = bannerContent.find((obj: FieldName) => obj.fieldName === "browseBannerImage");
    browseBannerTitle = bannerContent.find((obj: FieldName) => obj.fieldName === "browseBannerTitle");
    browseBannerSubTitle = bannerContent.find((obj: FieldName) => obj.fieldName === "browseBannerSubTitle");
    browseBannerLegalInfo = bannerContent.find((obj: FieldName) => obj.fieldName === "browseBannerLegalInfo");
  }

  const handleAddToCart = async () => {
    setShowOverlay(true);
    const response: any = await postBrowsePage(browseBanner?.cardId);

    if (response?.ecommerceAction === "error") {
      setToast({
        ...toast,
        show: true,
        variant: "danger",
        header: "Error",
        message: `${response?.message}`,
      });
      setShowOverlay(false);
      return;
    } else {
      if (response?.["_links"]?.["ec:windowLocation"]?.href) {
        navigate(response?.["_links"]?.["ec:windowLocation"]?.href);
      }
    }
  };

  return (
    <>
      {browseBannerBullets?.content &&
      browseBannerImage?.fileURL &&
      browseBannerTitle?.content &&
      browseBannerSubTitle?.content &&
      location.pathname === PATH.BROWSE ? (
        <div className="banner-container">
          <div className="container">
            <div className="banner-content">
              <h3>{browseBannerTitle?.content}</h3>
              <h5>
                <span>{setSpeeds(browseBannerSubTitle?.content, browseBanner)}</span>
              </h5>
              <h1>{browseBanner.displayPrice}</h1>
              <div className="special-offer-details">
                <span className="special-offer-legal-info-link ms-3" onClick={() => setShowLegalInfoModal(true)}>
                  Offer Details
                </span>
                <div className="row mt-2">
                  <span
                    dangerouslySetInnerHTML={{ __html: setSpeeds(browseBannerBullets?.content, browseBanner) }}
                    className="browse-banner-bullets"
                  />
                </div>
              </div>
              <button type="button" className="btn btn-primary banner-customize-button mt-3" onClick={() => handleAddToCart()}>
                Customize
              </button>
            </div>
            <div className="banner-image">
              {browseBanner?.label && Object.keys(browseBanner?.label).length > 0 ? (
                <div className="banner-label-container">
                  <CardBroadbandLabel broadbandLabel={browseBanner.label} bannerOffer={true} />
                </div>
              ) : (
                <img src={browseBannerImage?.fileURL} className="banner-promo-image" alt={`Comporium ${browseBannerTitle?.content}`} />
              )}
            </div>
          </div>
          <Modal show={showLegalInfoModal} onHide={() => setShowLegalInfoModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Offer Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div dangerouslySetInnerHTML={{ __html: browseBannerLegalInfo?.content }} />
            </Modal.Body>
          </Modal>
        </div>
      ) : null}
      {browseBannerMessage !== "" ? (
        <div className="browse-banner-message">
          <div className="container mt-5">{<div dangerouslySetInnerHTML={{ __html: browseBannerMessage }} />}</div>
        </div>
      ) : null}
    </>
  );
};

export default Banner;
